var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "goods_drawer_config",
      attrs: {
        model: _vm.value.config,
        disabled: _vm.disabled,
        rules: _vm.rules,
      },
    },
    [
      _c(
        "el-form-item",
        { attrs: { prop: "type" } },
        [
          _c("div", { staticClass: "label" }, [
            _vm._v(" 产品抽屉头部配置方式 "),
          ]),
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.value.config.type,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "type", $$v)
                },
                expression: "value.config.type",
              },
            },
            [
              _c("el-radio", { attrs: { label: "1" } }, [
                _vm._v("填写名称形式"),
              ]),
              _c("el-radio", { attrs: { label: "2" } }, [
                _vm._v("上传头图形式"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "box" },
        [
          _vm.value.config.type === "1"
            ? [
                _c(
                  "el-form-item",
                  { attrs: { prop: "name" } },
                  [
                    _c("div", { staticClass: "label" }, [
                      _vm._v("产品抽屉名称"),
                    ]),
                    _c("el-input", {
                      attrs: {
                        placeholder: "输入10个字以内的名称",
                        clearable: "",
                      },
                      model: {
                        value: _vm.value.config.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.value.config, "name", $$v)
                        },
                        expression: "value.config.name",
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.value.config.type === "2"
            ? [
                _c("div", { staticClass: "title" }, [_vm._v(" 抽屉头部图片 ")]),
                _c("el-form-item", { attrs: { prop: "header_image" } }, [
                  _c(
                    "div",
                    { staticClass: "upload-item-wrap" },
                    [
                      _c("upload-file", {
                        ref: "uploadBanner",
                        attrs: {
                          "link-url": _vm.linkUrl,
                          tempurl: _vm.value.config.header_image,
                          canDel: Boolean(_vm.value.config.header_image),
                          deletePadding: true,
                          uploadInfo: _vm.uploadInfo,
                        },
                        on: {
                          onDelete: _vm.onDelete,
                          emitUploadFile: _vm.emitUploadFile,
                        },
                      }),
                      _c(
                        "div",
                        { staticClass: "right" },
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { margin: "0" },
                              on: { click: _vm.onUpload },
                            },
                            [_vm._v("上传图片")]
                          ),
                          _vm.pictureList.length > 0
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.selectPicture },
                                },
                                [_vm._v(" 选择图片 ")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "tips" }, [
                    _vm._v(
                      " 建议尺寸为690*92，支持JPG、PNG等格式，大小不超过2M "
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "title" }, [_vm._v(" 选择菜单 ")]),
                _c(
                  "el-form-item",
                  { attrs: { prop: "category_id" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { clearable: "", placeholder: "请选择菜单" },
                        model: {
                          value: _vm.value.config.category_id,
                          callback: function ($$v) {
                            _vm.$set(_vm.value.config, "category_id", $$v)
                          },
                          expression: "value.config.category_id",
                        },
                      },
                      _vm._l(_vm.menuListFilter, function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { label: item.show_name, value: item.id },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "el-form-item",
        { attrs: { prop: "number" } },
        [
          _c("div", { staticClass: "label" }, [
            _vm._v("商品数量（可展示5-20商品）"),
          ]),
          _c("el-input", {
            attrs: { clearable: "", placeholder: "请输入" },
            model: {
              value: _vm.value.config.number,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "number", $$v)
              },
              expression: "value.config.number",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { prop: "bg_color" } },
        [
          _c("div", { staticClass: "label" }, [_vm._v("产品展示区背景色")]),
          _c("el-color-picker", {
            model: {
              value: _vm.value.config.bg_color,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "bg_color", $$v)
              },
              expression: "value.config.bg_color",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "margin_top",
          attrs: {
            prop: "margin_top",
            rules: [{ type: "number", message: "间距必须为数字值" }],
          },
        },
        [
          _c("div", { staticClass: "label" }, [_vm._v(" 与上方组件的间距 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入间距", clearable: "" },
            model: {
              value: _vm.value.config.margin_top,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "margin_top", _vm._n($$v))
              },
              expression: "value.config.margin_top",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "z_index",
          attrs: {
            prop: "z_index",
            rules: [
              {
                required: true,
                pattern: /^(?:[1-9]|[1-9][0-9])$/,
                message: "请输入1-99之间的整数！",
              },
            ],
          },
        },
        [
          _c("div", { staticClass: "label" }, [_vm._v(" 层级高度值 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入层级高度值", clearable: "" },
            model: {
              value: _vm.value.config.z_index,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "z_index", _vm._n($$v))
              },
              expression: "value.config.z_index",
            },
          }),
        ],
        1
      ),
      _vm.showPictureLibrary
        ? _c("picture-library", {
            attrs: {
              configData: _vm.value,
              pictureList: _vm.pictureList,
              depot: _vm.depot,
            },
            on: {
              onClose: function ($event) {
                _vm.showPictureLibrary = false
              },
              onSubmit: _vm.onChangePic,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }